import PluginModel from '../../../thd-pip/plugin.model';

class ProductSpecificationsModel extends PluginModel {}

export default ProductSpecificationsModel;
